/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const ModuleCard = ({ icon: Icon, title, t, count }) => {
    return (
        <div className='d-flex align-items-center gap-2'>
            <div className='p-8px border-radius-8px d-flex w-44px h-44px justify-content-center align-items-center background-primary-100'>
                <Icon className='btn-icon-svg-24px icon-color-general-950' />
            </div>

            <p className='fs-20px ibl-font-w-600 font-color-text-950 mb-0'>{t(title)}</p>

            <div className='d-flex justify-content-center align-items-center border-radius-8px w-20px background-shades-200'>
                <p className='fs-14px ibl-font-w-500 font-color-shades-500 px-1 mb-0'>{count}</p>
            </div>
        </div>
    );
};

export default ModuleCard;
